export { default } from './SectionCallToAction';